import Aqumen from "@aqumen/sdk";
import React, {useState} from "react";
import {useIntl} from "react-intl";
import {useSelector} from "react-redux";
import {useDebouncedCallback} from "use-debounce";

import {blurOnEnter} from "@/library/utility/blur_on_enter.js";

export function AccountFullNameTile(props) {
  const intl = useIntl();

  const session = useSelector(s => s.accessControlSession);
  const [fullName, setFullName] = useState(props.user.fullName ?? "");

  const submit = (value) => {
    Aqumen.User.update(session, {id: props.user.id}, {fullName: value});
  };
  const debouncedSubmit = useDebouncedCallback(submit, 1000);

  const handleChange = (event) => {
    setFullName(event.target.value);
    debouncedSubmit(event.target.value);
  };

  const handleBlur = (event) => {
    debouncedSubmit.cancel();
    if (event.target.value !== props.user.fullName) {
      return submit(event.target.value);
    }
  };

  const disabled = Boolean(props.user.archivedAt);
  return (
    <div className="account-full-name-tile">
      <label className="account-full-name label">
        <span className="account-full-name label-text">
          {intl.formatMessage({id: "account.properties.fullName.label"})}
        </span>
        <input className="account-full-name"
               type="text"
               disabled={disabled}
               value={fullName}
               onBlur={handleBlur}
               onChange={handleChange}
               onKeyUp={blurOnEnter}/>
      </label>
    </div>
  );
}
